const value = {
    noSystems: 'Нет доступных систем',
    finished: 'Прошел',
  };

export default value;
